export default __webpack_public_path__ + "static/media/mail.481168bc.svg";